import { Context } from 'chartjs-plugin-datalabels';
import {
	IChartPoint,
	IXAxesMinMax,
} from 'modules/admin-panel/pages/results/models';
import {
	CHART_Y_RANGE,
	VALUE_TO_USE_MAX_DEFAULT,
	VALUE_TO_USE_MIN_DEFAULT,
	X_AXES_DEFAULT_MAX,
	X_AXES_DEFAULT_MIN,
	X_AXES_STEP,
} from './chartConstants';

const getMinValue = (minChartValue: number) => {
	if (minChartValue > VALUE_TO_USE_MIN_DEFAULT) {
		return X_AXES_DEFAULT_MIN;
	}
	const min = Math.floor(minChartValue / 10) * 10;

	return minChartValue - min < X_AXES_STEP ? min - X_AXES_STEP : min;
};

const getMaxValue = (maxChartValue: number) => {
	if (maxChartValue < VALUE_TO_USE_MAX_DEFAULT) {
		return X_AXES_DEFAULT_MAX;
	}
	const max = Math.ceil(maxChartValue / 10) * 10;

	return max - maxChartValue < X_AXES_STEP ? max + X_AXES_STEP : max;
};

export const getMinAndMaxXAxesValues = (
	xAxesValues?: IChartPoint[],
): IXAxesMinMax => {
	if (!xAxesValues) {
		return {
			min: X_AXES_DEFAULT_MIN,
			max: X_AXES_DEFAULT_MAX,
		};
	}
	const xAxesItems = [] as number[];
	xAxesValues.forEach((item) => {
		xAxesItems.push(item.x);
	});
	const min = Math.min(...xAxesItems);
	const max = Math.max(...xAxesItems);

	return {
		min: getMinValue(min) < 0 ? 0 : getMinValue(min),
		max: getMaxValue(max) > 100 ? 100 : getMaxValue(max),
	};
};

export const getLongestLabelString = (label: string) => {
	return label.split('\n').reduce((longestStr, curStr) => {
		if (!longestStr || curStr.length > longestStr.length) {
			return curStr;
		}
		return longestStr;
	});
};

export const getChartParams = (
	context: Context,
	minAndMaxTicksValues: IXAxesMinMax,
) => {
	const { min, max } = minAndMaxTicksValues;
	const { chart } = context;
	const { chartArea } = chart;
	const chartXRange = max - min;
	const chartWidthPx = chartArea.right - chartArea.left;
	const chartHeightPx = chartArea.bottom - chartArea.top;
	const xRatio = chartXRange / chartWidthPx;
	const yRatio = CHART_Y_RANGE / chartHeightPx;

	return {
		minX: min,
		maxX: max,
		chart,
		chartArea,
		chartXRange,
		chartWidthPx,
		chartHeightPx,
		xRatio,
		yRatio,
	};
};
